import * as PIXI from 'pixi.js';
import { storage } from '../storage';
import { clickDelay } from '../staticData';

const app = new PIXI.Application({ resizeTo: window });
const pixiBG = new PIXI.Container();
pixiBG.sortableChildren = true;
// console.log('IND', `/spacebar-clicker/assets/planets/planet_${storage.GALAXY_IND + 1}.png`)
let planet;
/*  eslint-disable*/
// Create the stars 
const stars = [];
// const starTexture = PIXI.Texture.from('/spacebar-clicker/assets/balls/ball_9.png');
const starTexture = PIXI.Texture.from('/spacebar-clicker/assets/star.png');
const starAmount = Math.floor(app.renderer.screen.width * app.renderer.screen.height / 200);

// console.log('star amount 1', starAmount)

// Create music
export const backgroundMusic = new Audio('/spacebar-clicker/assets/sounds/spaceship.mp3')
backgroundMusic.loop = true
backgroundMusic.volume = 0.5;

export function setSpace() {
    document.getElementById("space").appendChild(app.view);
    app.stage.addChild(pixiBG)
    drawPlanet(true)

    for (let i = 0; i < starAmount; i++) {
        newStar()
    }
    startSky()
}

// stars settings
let cameraZ = 2;
const fov = 50;
// const fov = 20;
// let baseSpeed = 0;
let baseSpeed = 0.125;
let speed = 0;
let warpSpeed = 0;

let tutorialWindow;
let buttonText;

export function showTutorial() {
    const text1 = 'Tab on your SpaceBarShip to \nstart earning light years'
    const text2 = 'Press your spacebar to \nstart earning light years'
    const text3 = 'Buy your first alien to help \nyou in your space journey'
    const isMobile = navigator.userAgentData.mobile
    if (isMobile) {
        drawStartTutorial(text2)
        document.getElementById('space-bar').addEventListener('click', clickStep)
    } else {
        drawStartTutorial(text1)
        document.addEventListener('keydown', spaceStep)
    }

    function clickStep() {
        document.getElementById('space-bar').removeEventListener('click', clickStep)
        firstBuy()
    }

    function spaceStep(event) {
        if (event.key === ' ' || event.key === 'Spacebar') {
            event.preventDefault();
            document.removeEventListener('keydown', spaceStep)
            firstBuy()
        }
    }

    function firstBuy() {
        tutorialWindow.visible = false
        const interval = setInterval(() => {
            if (storage.COINS >= 25n && !tutorialWindow.visible) {
                drawStartTutorial(text3)
                document.getElementById('first-buy-btn').addEventListener('click', hideTutorial)
                clearInterval(interval)
            }
        }, 1000)
    }
    function hideTutorial() {
        // console.log('HIDE TUTORIAL')
        tutorialWindow.visible = false
        document.getElementById('first-buy-btn').removeEventListener('click', hideTutorial)
    }
}
function drawStartTutorial(text) {
    if (!tutorialWindow) {
        tutorialWindow = new PIXI.Graphics();
        tutorialWindow.beginFill(0x000080, 0.5);
        tutorialWindow.lineStyle(2, 0xFF0000);
        if (window.innerWidth < 700) {
            tutorialWindow.drawRect(0, 0, 200, 100);
            tutorialWindow.position.x = window.innerWidth - tutorialWindow.width;
            tutorialWindow.position.y = window.innerHeight - tutorialWindow.height;
        } else {
            tutorialWindow.drawRect(0, 0, 400, 100);
            tutorialWindow.position.x = (window.innerWidth - tutorialWindow.width) / 2;
            tutorialWindow.position.y = window.innerHeight / 2 - tutorialWindow.height * 2;
        }
        tutorialWindow.zIndex = 200;

        buttonText = new PIXI.Text();
        buttonText.style = {
            fontFamily: ['Helvetica', 'Arial', 'sans-serif'],
            fontSize: 18,
            fontWeight: "bold",
            // align: 'left',
            fill: 0xffffff,
            wordWrapWidth: 400,
            align: 'center'
        };
        buttonText.anchor.set(0.5, 0.5);
        buttonText.position.x = 200;
        buttonText.position.y = 50;
        tutorialWindow.addChild(buttonText);
        pixiBG.addChild(tutorialWindow);
    }
    tutorialWindow.visible = true;
    buttonText.text = text;


}

//PLANET COMING FURTHER
let fadeOutInt = null
const planetFadeOut = (width) => {
    fadeOutInt = setInterval(() => {
        // console.log('FADING OUT')
        if (planet.width <= width) clearInterval(fadeOutInt)
        // else if (planet.height <= planetDefSize.width) clearInterval(interval)
        else {
            planet.width -= planet.width * 0.008
            planet.height -= planet.height * 0.008
        }
    }, 30)
}
let currentPlanetSizeInd = 0.01
//PLANET COMING CLOSER
export function movePlanet(sizeInd) {
    if (planet) {
        const newWidth = planetDefSize.width * 5 * sizeInd
        // console.log('IND', sizeInd, currentPlanetSizeInd)
        if (sizeInd === currentPlanetSizeInd) return;
        else if (newWidth > planet.width) {
            clearInterval(fadeOutInt)
            clearInterval(zoomInInt)
            // console.log('IND IN', fadeOutInt)

            planetZoomIn(sizeInd)
        }
        else {
            clearInterval(zoomInInt)
            clearInterval(fadeOutInt)
            // console.log('IND OUT', zoomInInt)

            planetFadeOut(newWidth)
        }
        currentPlanetSizeInd = sizeInd
    }
}
let zoomInInt = null
const planetZoomIn = (sizeInd, speedInd = 0.008) => {
    // console.log('FADING STARTED')

    let height = planetDefSize.height * 5 * sizeInd
    height = height > window.innerHeight ? window.innerHeight : height
    const yCenter = app.renderer.screen.height / 2
    if (zoomInInt) clearInterval(zoomInInt)
    if (planet && planet.height < height)
        zoomInInt = setInterval(() => {
            if (planet.y < yCenter) planet.y += 0.5
            // console.log('HEIGHT size', height, planet.height)
            // if (planet) {
            // console.log('FADING IN')
            if (planet.height >= height) {
                // console.log('FADING STOPED')

                clearInterval(zoomInInt)
            }
            planet.width += planet.width * speedInd
            planet.height += planet.height * speedInd
            // }
        }, 30)
}

let speedDown = null
const maxSpeed = 0.3
export function updateStarsSpeed() {
    if (speedDown) clearTimeout(speedDown)
    if (baseSpeed < maxSpeed) {
        baseSpeed += 0.01
    }
    speedDown = setTimeout(() => {
        const interval = setInterval(() => {
            if (baseSpeed <= 0.03) clearInterval(interval)
            else baseSpeed -= 0.01
        }, 100)
    }, clickDelay)
}


const newStar = () => {
    const star = {
        sprite: new PIXI.Sprite(starTexture),
        z: 0,
        x: 0,
        y: 0,
    };

    star.sprite.anchor.x = 0.5;
    star.sprite.anchor.y = 0.7;
    // randomizeStar(star, true);
    // app.stage.addChild(star.sprite);
    // stars.push(star);


    star.sprite.zIndex = 50
    randomizeStar(star, true);
    pixiBG.addChild(star.sprite);
    stars.push(star);
    return star
}

function randomizeStar(star, initial) {
    star.z = initial ? Math.random() * 2000 : cameraZ + Math.random() * 1000 + 2000;
    // star.z = initial ? Math.random() * 2000 : cameraZ + Math.random() * 1000 + 2000;

    // Calculate star positions with radial random coordinate so no star hits the camera.
    const deg = Math.random() * Math.PI * 2;
    const distance = Math.random() * 50 + 1;

    star.x = Math.cos(deg) * distance;
    star.y = Math.sin(deg) * distance;
}
const planetDefSize = {
    width: 0,
    height: 0
}

const loadTexture = async function (from) {
    try {
        const t = await PIXI.Texture.fromURL(from);
        return t;
    } catch (e) {
        return null;
    }
}


let newPlanet = null
async function drawPlanet(isNew = false) {
    // console.log('Drawing started')
    let texture;
    try {
        texture = await loadTexture(`/spacebar-clicker/assets/planets/planet_${storage.GALAXY_IND}.png`)
        if (!texture) texture = await loadTexture(`/spacebar-clicker/assets/planets/planet_1.png`)
    } catch (err) {
        console.log(err)
    }
    const newSprite = new PIXI.Sprite(texture);
    if (isNew) newSprite.zIndex = 100
    else newSprite.zIndex = 1
    newSprite.alpha = 1
    newSprite.anchor.set(0.5);
    newSprite.width = newSprite.width * 0.3
    newSprite.height = newSprite.height * 0.3
    // if (window.innerHeight > 350) {
    //     newSprite.x = window.innerWidth / 2 - newSprite.width / 2
    // } else {
    //     newSprite.x = newSprite.width * 2
    // }
    newSprite.x = screenCenter.x
    newSprite.y = screenCenter.y
    planetDefSize.width = newSprite.width
    planetDefSize.height = newSprite.height

    // console.log('width2', newSprite.width)
    // if (planet) pixiBG.removeChild(planet)
    pixiBG.addChild(newSprite);
    if (isNew) planet = newSprite;
    else newPlanet = newSprite

    function animate() {
        planet.rotation += 0.001;
    }
    if (isNew) app.ticker.add(animate);
}

window.addEventListener('resize', handleResize);
const screenCenter = {
    x: app.renderer.screen.width / 2,
    y: window.innerHeight > 450 ? app.renderer.screen.height / 2 : app.renderer.screen.height / 5
}

function handleResize() {
    if (window.innerHeight <= 450) {
        screenCenter.y = app.renderer.screen.height / 5
        if (planet) {

            planet.y = screenCenter.y
        }
    }
    screenCenter.x = app.renderer.screen.width / 2
    planet.x = screenCenter.x
}
// Speed up to next galaxy
export async function speedGalaxy() {
    warpSpeed = 0.3
    planetZoomIn(1.8, 0.01)
    // console.log('PLANET WAS', planet._texture.textureCacheIds)
    let minSize = planetDefSize.height * 7
    minSize = window.innerHeight < minSize ? window.innerHeight : minSize
    drawPlanet()
    const interval = setInterval(() => {
        // console.log('PLANET IS', planet._texture.textureCacheIds, planet.height, planetDefSize.height * 7)
        if (planet.height >= minSize) {
            function dissolve() {
                // console.log('DISSOLVING')
                planet.alpha -= 0.01;
                if (planet.alpha <= 0) {
                    // console.log('TRANSPARENT', planet.alpha)
                    app.ticker.remove(dissolve)
                    pixiBG.removeChild(planet)
                    planet = newPlanet;
                    planet.zIndex = 100
                }
            }
            app.ticker.add(dissolve);
            warpSpeed = 0;
            baseSpeed = 0;
            clearInterval(fadeOutInt)
            clearInterval(zoomInInt)
            clearInterval(interval)
        }
    }, 50)
}

const starStretch = 5;
const starBaseSize = 0.05;
function startSky() {
    // Listen for animate update
    app.ticker.add((delta) => {
        // Simple easing. This should be changed to proper easing function when used for real.
        speed += (warpSpeed - speed) / 20;
        cameraZ += delta * 20 * (speed + baseSpeed);
        const starAmount = Math.floor(app.renderer.screen.width * app.renderer.screen.height / 200);
        // console.log('star amount', starAmount)
        for (let i = 0; i < starAmount; i++) {
            let star = stars[i];
            if (!star) star = newStar()

            if (star.z < cameraZ) randomizeStar(star);


            // Map star 3d position to 2d with really simple projection
            const z = star.z - cameraZ;

            star.sprite.x = star.x * (fov / z) * app.renderer.screen.width + screenCenter.x;
            star.sprite.y = star.y * (fov / z) * app.renderer.screen.width + screenCenter.y;
            // star.sprite.x = star.x * (fov / z) * app.renderer.screen.width + app.renderer.screen.width / 2;
            // star.sprite.y = star.y * (fov / z) * app.renderer.screen.width + app.renderer.screen.height / 2;
            // Calculate star scale & rotation.
            const dxCenter = star.sprite.x - app.renderer.screen.width / 2;
            const dyCenter = star.sprite.y - app.renderer.screen.height / 2;
            const distanceCenter = Math.sqrt(dxCenter * dxCenter + dyCenter * dyCenter);
            const distanceScale = Math.max(0, (2000 - z) / 2000);

            star.sprite.scale.x = distanceScale * starBaseSize;
            // Star is looking towards center so that y axis is towards center.
            // Scale the star depending on how fast we are moving, what the stretchfactor is
            // and depending on how far away it is from the center.
            star.sprite.scale.y = distanceScale * starBaseSize
                + distanceScale * speed * starStretch * distanceCenter / app.renderer.screen.width;
            star.sprite.rotation = Math.atan2(dyCenter, dxCenter) + Math.PI / 2;
        }
    });
}
// Original timing of the screensaver
